import { useEffect, useRef } from 'react';

interface Handlers {
  onToggle?: () => void;     // Space
  onSkip?: () => void;       // S
  onReset?: () => void;      // R
  onNew?: () => void;        // N
  onFullscreen?: () => void; // F
}

/** Global desktop keyboard shortcuts (ignored while typing in a field). */
export function useKeyboardShortcuts(handlers: Handlers) {
  const ref = useRef(handlers);
  ref.current = handlers;

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      const el = e.target as HTMLElement | null;
      const tag = el?.tagName;
      if (tag === 'INPUT' || tag === 'TEXTAREA' || el?.isContentEditable) return;
      if (e.metaKey || e.ctrlKey || e.altKey) return;
      switch (e.key) {
        case ' ': e.preventDefault(); ref.current.onToggle?.(); break;
        case 'n': case 'N': ref.current.onNew?.(); break;
        case 'f': case 'F': ref.current.onFullscreen?.(); break;
        case 's': case 'S': ref.current.onSkip?.(); break;
        case 'r': case 'R': ref.current.onReset?.(); break;
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);
}
